export default __webpack_public_path__ + "static/media/Megosu - Made.com - 5.4eb9d014.jpg";